import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Button } from "@mui/material";
import { icons } from "constants/icons";
import { PAGES } from "constants/pages";
import { useAppDispatch } from "hooks/reduxHooks";
import { setCurrentClinician } from "store/ClinicianStore/clinicianSlice";
import { AuthRepository } from "repositories/AuthRepository";

const SubscriptionSuccess: React.FC = () => {
  const history = useHistory();
  const dispatch = useAppDispatch();

  useEffect(() => {
    const reloadClinician = async () => {
      const authRepository = AuthRepository.getInstance();
      const currentClinician = await authRepository.getMe();
      dispatch(setCurrentClinician(currentClinician));
    };

    reloadClinician();
  }, [dispatch]);

  const containerStyle = {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "24px",
    background:
      "linear-gradient(135deg, rgba(112,104,175,0.08) 0%, rgba(235,42,51,0.08) 100%)",
  } as const;

  const cardStyle = {
    backgroundColor: "#ffffff",
    borderRadius: "16px",
    padding: "32px",
    maxWidth: "520px",
    width: "100%",
    textAlign: "center" as const,
    boxShadow: "0 10px 25px rgba(0,0,0,0.06), 0 2px 8px rgba(0,0,0,0.04)",
  };

  const titleStyle = {
    margin: 0,
    marginTop: "12px",
    color: "#111827",
    fontSize: "28px",
    fontWeight: 800,
    fontFamily: "SofiaPro",
  } as const;

  const subtitleStyle = {
    marginTop: "8px",
    marginBottom: "24px",
    color: "#4B5563",
    fontSize: "16px",
    lineHeight: 1.6,
    fontFamily: "SofiaPro",
  } as const;

  const iconStyle = {
    width: "64px",
    height: "64px",
    display: "block",
    margin: "0 auto",
  } as const;

  const buttonStyle = {
    textTransform: "none" as const,
    fontWeight: 700,
    padding: "10px 20px",
    borderRadius: "10px",
    fontFamily: "SofiaPro",
    background: "linear-gradient(87.29deg, #7068AF -42.06%, #EB2A33 120.03%)",
  };

  return (
    <div style={containerStyle}>
      <div style={cardStyle}>
        <img src={icons.checkCircle} alt="success" style={iconStyle} />
        <h2 style={titleStyle}>Subscription Activated</h2>
        <p style={subtitleStyle}>
          Thanks for upgrading! Your subscription is now active. Enjoy premium
          features and priority support.
        </p>
        <Button
          variant="contained"
          style={buttonStyle}
          onClick={() => history.push(PAGES.homeScreen)}
        >
          Go to Home
        </Button>
      </div>
    </div>
  );
};

export default SubscriptionSuccess;
